(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const enhance = () => {
    document.querySelectorAll('.card-wrapper, .multicolumn-card, .kt-watch-card').forEach(el => el.classList.add('kt-depth-ready'));
    if (!reduce && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), {threshold:.12});
      document.querySelectorAll('.kt-luxury__proof div, .product__info-container, .multicolumn-card').forEach(el => { el.classList.add('kt-reveal'); observer.observe(el); });
    }
    if (!fine || reduce) return;
    document.querySelectorAll('.kt-depth-ready').forEach(el => {
      if (el.dataset.ktMotionBound) return;
      el.dataset.ktMotionBound='true';
      el.addEventListener('pointermove', e => {
        const r=el.getBoundingClientRect(), x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
        el.style.transform=`rotateX(${-y*3}deg) rotateY(${x*3}deg) translateY(-6px)`;
      }, {passive:true});
      el.addEventListener('pointerleave', () => { el.style.transform=''; }, {passive:true});
    });
  };
  document.addEventListener('DOMContentLoaded', enhance);
  document.addEventListener('shopify:section:load', enhance);
})();